// Web shim for react-native-image-picker using HTML file input
const pickFile = (options, multiple) =>
  new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = options?.mediaType === 'video' ? 'video/*' : options?.mediaType === 'photo' ? 'image/*' : 'image/*,video/*';
    input.multiple = multiple || false;
    input.onchange = (e) => {
      const files = Array.from(e.target.files || []);
      if (!files.length) {
        resolve({ didCancel: true });
        return;
      }
      const assets = files.map((f) => ({
        uri: URL.createObjectURL(f),
        fileName: f.name,
        fileSize: f.size,
        type: f.type,
        width: 0,
        height: 0,
      }));
      resolve({ didCancel: false, assets });
    };
    input.oncancel = () => resolve({ didCancel: true });
    input.click();
  });

export const launchImageLibrary = (options, callback) => {
  const promise = pickFile(options, options?.selectionLimit !== 1);
  if (callback) {
    promise.then(callback);
    return { cancel: () => {} };
  }
  return promise;
};

export const launchCamera = (options, callback) => {
  const result = { didCancel: false, errorCode: 'camera_unavailable', errorMessage: 'Camera is not available on web' };
  if (callback) {
    callback(result);
    return { cancel: () => {} };
  }
  return Promise.resolve(result);
};

export const ImagePicker = { launchImageLibrary, launchCamera };
export default ImagePicker;
